




















































































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Route } from 'vue-router'
import { isPlatformAndroid } from '@/utils/cordova'
import { reloadApp } from '@/utils'

@Component
export default class HeaderMenu extends Vue {
  $store!: ExStore
  open = false
  unregisteredNavigationGuard: null | Function = null

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get isRelative() {
    return this.userInfo.isPatientRelative
  }

  get routePrefix() {
    return this.isRelative ? 'Relative' : 'Patient'
  }

  handleClickOpen() {
    this.open = true
  }

  handleClickClose() {
    this.open = false
  }

  handlePdCreate() {
    if (isPlatformAndroid()) {
      this.$postMessage.showPdCameraView(
        this.userInfo.id,
        this.userInfo.isPatient
      )
      return
    }
    this.$router.push({ name: 'PdCreate' })
  }

  handleProfielEdit() {
    if (this.isRelative) {
      this.$router.push({ name: 'RelativeProfileEdit' })
      return
    }
    this.$router.push({ name: 'PatientProfileEdit' })
  }

  async handleClickLogout() {
    this.$postMessage.saveSession('', '')
    await this.$store.dispatch('user/logout')
    reloadApp()
  }

  created() {
    this.unregisteredNavigationGuard = this.$router.beforeEach(
      (to: Route, from: Route, next: () => void) => {
        this.open = false
        next()
      }
    )
  }

  destroyed() {
    if (typeof this.unregisteredNavigationGuard === 'function') {
      this.unregisteredNavigationGuard()
    }
  }
}
